export default __webpack_public_path__ + "static/media/route.0e0cfa24.svg";